import { makeStyles } from '@material-ui/core/styles';
import {
  BackgroundColors,
  SecondaryColors,
  SurfaceColors,
  TextColors,
  TextOpacities,
} from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    color: TextColors.dark,

    '& $filters': {
      background: SurfaceColors.dark,

      '& .title': {
        color: hexToRGBA(BackgroundColors.dark, TextOpacities.light2),
      },
    },
    '& $tab': {
      color: BackgroundColors.light,
    },
    '& $tabIcon': {
      color: SecondaryColors.dark,
    },
    '& $tabPanel': {
      borderBottom: `1px solid ${hexToRGBA(BackgroundColors.dark, TextOpacities.light4)}`,
    },
    '& $tabPanelTitle': {
      color: BackgroundColors.dark,
    },
    '& $link': {
      color: TextColors.light,
    },
  },
};

const darkTheme = {
  root: {
    color: TextColors.light,

    '& $filters': {
      background: SurfaceColors.light,

      '& .title': {
        color: hexToRGBA(BackgroundColors.light, TextOpacities.dark2),
      },
    },

    '& $tab': {
      color: BackgroundColors.dark,
    },

    '& $tabIcon': {
      color: SecondaryColors.dark,
    },
    '& $tabPanel': {
      borderBottom: `1px solid ${hexToRGBA(BackgroundColors.light, TextOpacities.dark4)}`,
    },
    '& $tabPanelTitle': {
      color: BackgroundColors.light,
    },
    '& $link': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,

      [muiTheme.breakpoints.down('sm')]: {
        width: '100%',
      },

      '&:not(.typography-small)': {
        '& $tab': {
          ...muiTheme.typography.body1,

          '& span': {
            fontWeight: 'bold',
          },
        },
      },

      '&.typography-small': {
        '& $tab': {
          ...muiTheme.typography.body2,

          '& span': {
            fontWeight: 'normal',
          },
        },
      },
    },
    filters: {
      alignItems: 'center',
      alignContent: 'center',

      display: 'flex',
      flexDirection: 'row',
      height: '61px',

      [muiTheme.breakpoints.down('sm')]: {
        width: '100%',
      },

      '& .title': {
        marginLeft: muiTheme.spacing(4),
      },
    },
    tabs: {
      minHeight: '27px',
      alignItems: 'baseline',
      width: '100%',
      margin: 'auto 0',

      '& .MuiTabScrollButton-root': {
        alignSelf: 'center',
        marginTop: '-3px',
        width: '32px',
      },

      '& .MuiTabs-indicator': {
        display: 'none',
      },
    },
    tab: {
      minHeight: '27px',
      minWidth: 0,
      opacity: 1,
      padding: 0,

      '&:not(:first-child)': {
        marginLeft: muiTheme.spacing(1.25),
      },

      '&:not(:last-child)': {
        marginRight: muiTheme.spacing(1.25),
      },
    },
    tabIcon: {
      verticalAlign: 'middle',
      display: 'inline-flex',
      marginLeft: '4px',
    },
    tabPanel: {
      padding: muiTheme.spacing(3, 4),
    },
    tabPanelTitle: {
      marginBottom: muiTheme.spacing(2),
    },
    tabPlaceholder: {
      display: 'none',
    },
    links: {
      width: '100%',
    },
    link: {
      fontWeight: 'normal',
      display: 'block',
      padding: '5px 0',
    },
  }),
  { name: 'GenMarketplaceTabFilter' },
);

export default useStyles;
